import { PureComponent } from 'react'
import styled from 'glamorous'
import map from 'lodash/map'
import Link from 'react-router-dom/Link'

import { $, getShortedString } from 'utils'
import { InertialScrolling, ImagePure, Tooltip } from 'components'

const Container = styled(Link)({
  display: 'flex',
  height: 130,
  marginBottom: 5,
  backgroundColor: 'white',
  borderRight: '3px solid transparent',
  transition: 'var(--borderTransition)',
  userDrag: 'none',
  WebkitUserDrag: 'none',
  '&:hover': {
    borderRight: '3px solid var(--violet)',
    cursor: 'pointer'
  }
}, ({ selected }) => selected && {
  borderRight: '3px solid var(--violet)',
})

const InfoContainer = styled.div({
  overflow: 'hidden',
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
})

const Header = styled.div({
  display: 'flex',
  height: 40,
  borderBottom: '1px solid var(--borderColor)',
})

const HeaderItem = styled.div({
  // flex: 1,
  height: '100%',
  display: 'flex',
  minWidth: 0,
  // flexBasis: '50%',
  lineHeight: '40px',
  paddingLeft: 25,
  paddingRight: 25,
  width: '18ex',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  borderRight: '1px solid var(--borderColor)',
  '&:last-child': {
    borderRight: 'none',
  }
}, ({ grow }) => grow && { flexGrow: 1, width: 'auto' })

const PhotoContainer = styled.div({
  flex: 1,
  padding: '15px 25px',
  overflow: 'hidden'
})

const PhotoInnerContainer = styled.div({
  display: 'flex',
  height: '100%',
  overflow: 'auto'
})

const MinPhoto = styled.div({
  marginRight: 5,
  '& img': {
    userDrag: 'none',
    WebkitUserDrag: 'none'
  }
})

class PersonListItem extends PureComponent {

  state = {
    portrait: this.props.person.portrait
  }

  componentWillReceiveProps(nextProps) {
    if (!nextProps.person.descriptors.some(d => d.portrait === this.state.portrait)) {
      this.setPortrait(nextProps.person.portrait)
    }
  }

  setPortrait = (portrait) => {
    this.setState({ portrait })
  }

  render() {
    const { person: { uuid, userData, descriptors, externalId = '' }, selected } = this.props
    const { portrait } = this.state

    return (
      $(Container, {
          key: uuid,
          selected,
          to: {
            pathname: `/persons/${uuid}`,
            search: window.location.search
          }
        },
        $(ImagePure, {
          src: portrait,
          width: 100,
          height: '100%',
        }),
        $(InfoContainer,
          $(Header,
            $(HeaderItem,
              $(Tooltip, { tip: `Luna ID ${uuid}`, position: 'top' }, getShortedString(uuid)),
            ),
            $(HeaderItem,
              $(Tooltip, { tip: `External ID ${externalId}`, position: 'top' }, getShortedString(externalId))
            ),
            $(HeaderItem, { grow: true }, userData)),
          $(PhotoContainer,
            $(PhotoInnerContainer,
              $(InertialScrolling,
                map(descriptors, (val, key) =>
                  $(MinPhoto, {
                    key,
                    onClick: () => this.setPortrait(val.portrait)
                  },
                    $(ImagePure, {
                      src: val.portrait,
                      width: 38,
                      height: 50,
                      isHoverable: true,
                    })
                  )
                )
              )
            )
          )
        )
      )
    )
  }
}


export default PersonListItem



// WEBPACK FOOTER //
// ./src/pages/Persons/PersonListItem.js